import React, { useContext, useState } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { useTranslation } from 'react-i18next';
import * as icons from '@boxine/tonies-ui/icons';
import { FocusShadow } from '../../styles/FocusStyles';
import Icon from '../Icon';
import { PreviewCardView } from './PreviewCardView';
const ActionButton = styled.button `
  border: none;
  background: none;
  cursor: pointer;
  font-family: ${props => props.theme.fonts.serif};
  padding: 0;
  display: flex;
  align-items: center;
  color: ${props => props.theme.Gray};
  transition: opacity 0.2s;
  transition-delay: 0.5s;
  opacity: ${props => (props.locking ? 0 : 1)};
  visibility: visible;
  position: relative;
  outline: none;

  @supports not (selector(:focus-visible)) {
    &.focus-visible,
    &:focus {
      outline: none;
      svg {
        ${FocusShadow}
        border-radius: 50%;
      }
    }
  }

  @supports selector(:focus-visible) {
    &:focus-visible {
      outline: none;
      svg {
        ${FocusShadow}
        border-radius: 50%;
      }
    }
  }
`;
const StyledActionIcon = styled(Icon) `
  width: 1.25rem;
  height: 1.25rem;
  margin-left: 0.75rem;
  position: relative;
  top: -0.4rem;
  margin-right: 0.1rem;

  path:nth-of-type(2) {
    fill: ${props => (props.locking ? props.theme.White : props.theme.Green)};
  }
`;
export const PreviewCardContainer = ({ 'data-trackingid': dataTrackingId, description = null, footer = null, header = null, isLocked = false, media, onActionClick = undefined, shadowColor = undefined, title, to, }) => {
    const theme = useContext(ThemeContext);
    const { t } = useTranslation(['PreviewCard']);
    const [locking, setLocking] = useState(isLocked);
    const showAction = onActionClick != null && onActionClick !== undefined && !isLocked;
    return (React.createElement(PreviewCardView, { "data-trackingId": dataTrackingId, to: to, title: title, description: description, shadowColor: shadowColor, isShadowShown: showAction, isLocked: locking, header: header, media: media, linkFooter: footer, shadowContent: React.createElement(React.Fragment, null,
            React.createElement(ActionButton, { tabIndex: locking ? -1 : 0, locking: locking, onClick: event => {
                    event.currentTarget.blur();
                    if (showAction) {
                        setLocking(true);
                        return Promise.resolve()
                            .then(() => onActionClick())
                            .catch(() => setLocking(false));
                    }
                }, "data-testid": "card-action", "data-trackingid": "content-tonie-overview__tonie-card__tonie-lock-checkmark" },
                locking ? t('MyTonieLocked') : t('MyTonieUnlocked'),
                React.createElement(StyledActionIcon, { title: null, locking: locking, fill: locking ? theme.Green : theme.White, type: locking ? icons.checkmarkFill : icons.plusFill }))) }));
};
